enum UserPlatform {
    Unknown,
    App,
    Mobile,
    Desktop,
}

export default UserPlatform;
